import axios from 'axios';


const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;




const api = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
});

api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.log("googleError",error);
        if (error.response?.status === 401 || error.response?.status === 403) {
            const originalRequestUrl = error.config?.url;

            // exclude specific routes login, signup, logout, googleAuth, googleCallback
            const excludedRoutes = [
                '/api/authenticate/login',
                '/api/authenticate/register',
                '/api/authenticate/logout',
                '/api/authenticate/forgotPassword',
                '/api/authenticate/resetPassword',
                '/api/authenticate/auth/google',
                '/api/authenticate/auth/google/callback',
            ];
            if (!excludedRoutes.some((route) => originalRequestUrl.includes(route))) {
                window.location.href = '/404NotFound';
            }
        }
        return Promise.reject(error);
    }
);

export default api;

// Question APIs
export const addQuestion = (questionData) => {
    return api.post(`/api/questions/addQuestion`, questionData);
};

export const compileCode=(codeData)=>{   
       
    const response=api.post(`/api/compiler/compile`,codeData);
    console.log('apiResponse', response);
    return response;

};

export const getQuestionInfo = (idQuestion) => {
    console.log("idQuestion in getQuestionInfo:", idQuestion);
    return api.get(`/api/questions/getQuestionInfo`, {
        params: { idQuestion: idQuestion.trim() }
    });
  };

export const getAllQuestions = () => {    
    return api.get(`/api/questions/getAllQuestions`);
};

export const getTopicsQuestions = (topicName) => {
    return api.get(`/api/questions/getTopicQuestions`, {
        params: {topicName: topicName.trim() }
    })
}

// Solution APIs
export const addSolution = (solutionData) => {
    return api.post(`/api/solutions/addSolution`, solutionData);
};

export const getSolutionInfo = () => {
    return api.get(`/api/solutions/getSolutionInfo`);
};

export const getQuestionSolutions = (idQuestion) => {
    return api.get(`/api/solutions/getQuestionSolutions`, {
        params: { idQuestion: idQuestion.trim() }
    });
};

// Submission APIs
export const addSubmission = (submissionData) => {
    return api.post(`/api/submissions/addSubmission`, submissionData);
};

export const getQuestionSubmissions = (idQuestion) => {
    return api.get(`/api/submissions/getQuestionSubmissions`, {
        params: { idQuestion: idQuestion.trim() }
    });
};

export const getSubmissionInfo = () => {
    return api.get(`/api/submissions/getSubmissionInfo`);
};

export const getUserSubmissions = () => {
    return api.get(`/api/submissions/getUserSubmissions`)
}

// AI Feedback APIs
export const addAIFeedback = (feedbackData) => {
    return api.post(`/api/aifeedback/addAIFeedback`, feedbackData);
};

export const getAIFeedbackInfo = () => {
    return api.get(`/api/aifeedback/getAIFeedbackInfo`);
};

// Resume Feedback APIs
export const analyzeResume = (analysisData) => {
    return api.post(`/api/resume/analyse`, {
        resume: analysisData.resume,
        jobDescription: analysisData.jobDescription
    });
};

export const analyzeFit = (analysisData) => {
    return api.post('/api/resume/analyse/fit', {
        resume: analysisData.resume,
        jobDescription: analysisData.jobDescription
    });
};

export const analyzeWording = (analysisData) => {
    return api.post('/api/resume/analyse/wording', analysisData);
};

export const getAIFeedbackResumeWording = (aiFeedbackPayload) => {
    return api.post(`/api/model/predict/resume/wording`, aiFeedbackPayload);
};

export const getAIFeedbackResumeRewriting = (aiFeedbackPayload) => {
    return api.post(`/api/model/predict/resume/rewriting`, aiFeedbackPayload);
};

// Courses API
export const getAllCourse = () => {
    return api.get(`/api/courses/getAllCourse`);
};

export const getUserCourses = () => {
    return api.get(`/api/courses/getUserCourses`)
}

// Topics API
export const getCourseTopics = (idCourse) => {
    return api.get(`/api/topics/getCourseTopics`, {
        params: { idCourse: idCourse.trim() }
    });
};

export const getAIFeedback = (aiFeedbackPayload) => {
    return api.post(`/api/model/predict`, aiFeedbackPayload);
};

export const login = (loginData) => {
    return api.post(`/api/authenticate/login`, loginData);
};

export const logout = () => {
    return api.post(`/api/authenticate/logout`);
    
};

// Authentication
export const signup = (signupData) => {
    return api.post(`/api/authenticate/register`, signupData);
};

export const forgotPassword = (email) => {
    return api.post(`/api/authenticate/forgotPassword`, { email });
};

export const resetPassword = (token, password) => {
    return api.post(`/api/authenticate/resetPassword`, { token, password });
};

export const verifyAccount = (token) => {
    return api.post(`/api/authenticate/verification`, { token });
};

export const resendVerification = (email) => {
    return api.post(`/api/authenticate/resend-verification`, { email });
};

export const googleAuth = () => {
    return api.get(`/api/authenticate/auth/google`);
};

export const googleRedirectCallback = (code) => {
    return api.post(`/api/authenticate/auth/google/callback`, { code });
};

export const getUser = () => {
    return api.get(`/api/authenticate/getUser`);
};

export const deleteAccount = () => {
    return api.delete('/api/account/delete');
};

export const changeUsername = (newUsername) => {
    return api.patch('/api/account/changeUsername', {newUsername});
};

export const changePassword = (currentPassword, newPassword) => {
    return api.patch('/api/account/changePassword', { currentPassword, newPassword });
};

// Interview 
export const getAllInterviewQnsAns = (domain) => {
    return api.post(`/api/interviews/getAllQnsAns`, {domain});
};

export const getOneInterviewQnsAns = () => {
    return api.get(`/api/interviews/getOneQnsAns`);
};

export const submitInterview = (submissionPayload) => {
    return api.post(`/api/interviews/submitInterview`, submissionPayload, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

export const getAttemptedInterview = () => {
    return api.get('/api/interviews/getAttemptedInterview');
};

export const createCheckoutSession = (priceId) => {
    return api.post('/api/payment/create-checkout-session', {priceId});
};

export const accessPortal = () => {
    return api.post('/api/payment/customer-portal');
};

export const renewSub = () => {
    return api.post('/api/payment/renew-subscription');
};

export const getSubscriptionStatus = () => {
    return api.get('/api/payment/get-subscription-status');
};

export const getActivePaymentMethod = () => {
    return api.get('/api/payment/get-active-payment-method');
};

// Dashboard
export const getRecommendedQuestions = (refresh) => {
    return api.post('/api/dashboard/getRecommendedQuestions', {refresh});
}